/* Cursor spotlight for panels marked [data-spot].
   Writes --mx/--my as percentages; the highlight itself is pure CSS, so this
   does nothing but move two numbers. Passive, and idle when nothing is hovered. */
(function () {
  function bind() {
    document.querySelectorAll('[data-spot]').forEach(function (el) {
      if (el.dataset.lusSpot) return;
      el.dataset.lusSpot = '1';
      var raf = null, x = 50, y = 50;
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        x = ((e.clientX - r.left) / r.width) * 100;
        y = ((e.clientY - r.top) / r.height) * 100;
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          el.style.setProperty('--mx', x + '%');
          el.style.setProperty('--my', y + '%');
        });
      }, { passive: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
  else bind();
  document.addEventListener('shopify:section:load', bind);
})();